import apiClient from './api-client';
import { FreelancerProfileSearchRequest } from '../models/requests/FreelancerProfileSearchRequest';
import { PaginatedResponse } from '../models/Pagination';
import { FreelancerProfile } from '../models/FreelancerProfile';

export const searchFreelancerProfiles = async (
  searchRequest: FreelancerProfileSearchRequest
): Promise<PaginatedResponse<FreelancerProfile>> => {
  const response = await apiClient.post(
    `/freelancer-profiles/search`,
    searchRequest
  );
  return response.data;
};

export const createProjectFreelancerAssociation = async (data: {
  projectId: number;
  freelancerProfileId: number;
}) => {
  const response = await apiClient.post(
    `/project-freelancer-profiles`,
    data
  );
  return response.data;
};

export const bulkInviteFreelancers = async (data: {
  projectId: number;
  freelancerProfileIds: number[];
}) => {
  const response = await apiClient.post(
    `/project-freelancer-profiles/bulk-invites`,
    data
  );
  return response.data;
};

export const getFreelancersByProject = async (projectId: number) => {
  const response = await apiClient.get(
    `/project-freelancer-profiles/projects/${projectId}`
  );
  return response.data;
};

export const getProjectsByFreelancerProfile = async (freelancerProfileId: number) => {
  const response = await apiClient.get(
    `/project-freelancer-profiles/freelancer-profiles/${freelancerProfileId}`
  );
  return response.data;
};

export const deleteAssociation = async (id: number) => {
  const response = await apiClient.delete(
    `/project-freelancer-profiles/${id}`
  );
  return response.data;
};